import { render, staticRenderFns } from "./FormsTable.vue?vue&type=template&id=5db198c0&scoped=true"
import script from "./FormsTable.vue?vue&type=script&lang=js"
export * from "./FormsTable.vue?vue&type=script&lang=js"
import style0 from "./FormsTable.vue?vue&type=style&index=0&id=5db198c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db198c0",
  null
  
)

export default component.exports